/* eslint-disable */
 import('./bootstrap.tsx') // see bootstrap.tsx for entrypoint
 export const dummy = 'This line is only needed if you see, isolatedModules issue'
